import ApiResponse from "../models/ApiResponse";
import HistoricalTestCaseResponse from "../models/HistoricalTestCaseResponse";
import PagedResponse from "../models/PagedResponse";
import Api from "./Api";
import HistoricalTestCaseSearchFilterRQ from "./HistoricalTestCaseSearchFilterRQ";

class HistoricalTestCasesApi {
  constructor(private api: Api) {}

  searchHistoricalTestCases(
    requestId: string,
    searchParams: {
      filter: HistoricalTestCaseSearchFilterRQ;
      pagination?: {
        pageIndex: number;
        pageSize: number;
      };
    },
  ): ApiResponse<PagedResponse<HistoricalTestCaseResponse>> {
    const { filter, pagination } = searchParams;
    let uri = `/test-request/v2/testrequests/${requestId}/historical-test-cases`;
    if (pagination) {
      const query = new URLSearchParams(Object.entries(pagination).map(([key, val]) => [key, String(val)]));
      uri = query ? `${uri}?${query}` : uri;
    }
    return this.api.post(uri, filter);
  }
}

export default HistoricalTestCasesApi;
